import { FILTER_SOURCES } from 'services/cfg/filter'
import { APICfg } from '../../api'
import { eventGetOne, eventParse, eventUpdate, eventWrite } from '../events'

const apiCfg = {
  endpoint: 'event',
  query: { [FILTER_SOURCES.status]: 'draft' },
  parse: eventParse,
  write: eventWrite,
  getOne: eventGetOne,
  update: eventUpdate,
} as APICfg

export default apiCfg
